/*
 * FILE: unified_ui/src/lib/versionCheck.ts
 * PURPOSE: Polls /version.json every 30s. If the build timestamp changed,
 *          forces a hard reload so every user always sees fresh code.
 *          Also injects a blocker script in index.html that runs before
 *          Vue mounts — catches stale HTML cached by aggressive WebViews.
 */

let currentVersion: string | null = null
let polling = false

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    return String(data.builtAt ?? '')
  } catch {
    return null
  }
}

export function startVersionCheck(intervalMs = 30_000): void {
  if (polling) return
  polling = true

  async function check() {
    const version = await fetchVersion()
    if (!version) return

    if (currentVersion === null) {
      // First load — just record the version
      currentVersion = version
      return
    }

    if (version !== currentVersion) {
      // New version detected — force hard reload
      console.log(`[versionCheck] New build detected: ${currentVersion} → ${version}. Reloading.`)
      window.location.reload()
    }
  }

  check()
  setInterval(check, intervalMs)
}
